import {
  IBackupRunOptions,
  ICreateBackupPayload,
  IRestoreBackupPayload,
  IRestorePreview,
  SimpleResult,
} from "../dto";
import { Api } from "../helpers";
import { IRydeProcess } from "../models";

export class BackupApi {
  // What the "Back up now" drawer offers: every company and every backupable entity.
  static async getRunOptions(): Promise<IBackupRunOptions | undefined> {
    const requestUrl = `/api/v1/core/backups/run/options`;
    const response = await Api.get<IBackupRunOptions>(requestUrl);

    return response?.data;
  }

  // On-demand backup (super-admin only, gated by the backup `create` permission). Runs as an async
  // backend process, tracked through the shared process drawer exactly like a restore.
  static async run(
    payload: ICreateBackupPayload,
  ): Promise<SimpleResult<IRydeProcess> | undefined> {
    const requestUrl = `/api/v1/core/backups/run`;
    const response = await Api.post<SimpleResult<IRydeProcess>>(
      requestUrl,
      payload,
    );

    return response?.data;
  }

  // Restore runs as an async backend process; the returned process is tracked via the shared
  // process drawer / watchers (polled against its own companyId, since this is a global page).
  static async restore(
    id: number,
    payload: IRestoreBackupPayload,
  ): Promise<SimpleResult<IRydeProcess> | undefined> {
    const requestUrl = `/api/v1/core/backups/${id}/restore`;
    const response = await Api.post<SimpleResult<IRydeProcess>>(
      requestUrl,
      payload,
    );

    return response?.data;
  }

  // Read-only "dry run": returns what a restore would do without changing any data.
  static async previewRestore(
    id: number,
    payload: IRestoreBackupPayload,
  ): Promise<SimpleResult<IRestorePreview> | undefined> {
    const requestUrl = `/api/v1/core/backups/${id}/restore/preview`;
    const response = await Api.post<SimpleResult<IRestorePreview>>(
      requestUrl,
      payload,
    );

    return response?.data;
  }
}
